import {
  GOODS_FETCHITEMS_LOAD,
  GOODS_FETCHITEMS_SUCCEED,
  GOODS_FETCHITEMS_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case GOODS_FETCHITEMS_LOAD:
      return { ...state, isFetchGoodsLoading: true, fetchGoodsError: null }
    case GOODS_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchGoodsLoading: false,
        goods: action.items,
        // pagination: { ...state.pagination, total: action.total },
      }
    case GOODS_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchGoodsLoading: false,
        goods: null,
        fetchGoodsError: action.fetchGoodsError,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/goods.js